/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CORE_STRINGS } from './Strings.constants';

/**
 * The data-id prefixes used in the Toolbar dropdown menu items.
 * @export
 */
export const TOOLBAR_DATA_ID_PREFIX = {
  accountMenu: `Account Menu`,
  helpMenu: `Help Menu`,
};

/**
 * The data-ids used in the Toolbar dropdown menu items.
 * @export
 */
export const TOOLBAR_DATA_IDS = {
  helpDropdownCustomerSuggestions: `${TOOLBAR_DATA_ID_PREFIX.helpMenu}: ${CORE_STRINGS.customerSuggestions}`,
  helpDropdownHelpCenter: `${TOOLBAR_DATA_ID_PREFIX.helpMenu}: ${CORE_STRINGS.helpCenter}`,
  helpDropdownMenu: `Toolbar: Help menu`,
  helpDropdownMySquiz: `${TOOLBAR_DATA_ID_PREFIX.helpMenu}: ${CORE_STRINGS.mySquiz}`,
  helpDropdownUserDocumentation: `${TOOLBAR_DATA_ID_PREFIX.helpMenu}: ${CORE_STRINGS.userDocumentation}`,
  userAccountDropdownMenu: `Toolbar: User account dropdown menu`,
  userAccountDropdownMyAccount: `${TOOLBAR_DATA_ID_PREFIX.accountMenu}: ${CORE_STRINGS.myAccount}`,
  userAccountDropdownSignOut: `${TOOLBAR_DATA_ID_PREFIX.accountMenu}: ${CORE_STRINGS.signOut}`,
};

/**
 * The data-ids used in the navigation sections.
 * @export
 */
export const NAV_SECTION_DATA_IDS = {
  account: 'Side Nav: Account',
  agency: 'Side Nav: Agency',
  organisation: 'Side Nav: Organization',
  resources: 'Side Nav: Resources',
};
